export const showSimulator = (simulator) => ({
    type: 'SHOW_SIMULATOR',
    simulator,
});

export const hideSimulator = () => ({
    type: 'HIDE_SIMULATOR',
});
